import type {EvaluatorOptions} from "./evaluator-options.js";
import type {TS} from "../../type/ts.js";

/**
 * Evaluates, or attempts to evaluate, a OmittedExpression
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function evaluateOmittedExpression(_options: EvaluatorOptions<TS.OmittedExpression>): undefined {
	return undefined;
}
